import React from 'react';
import styles from './AssetsBlock.module.scss';
export const AssetsBlock = ({ text }) => {
  return (
    <div className={styles.assetsBlock}>
      <span title={text}>{text}</span>
    </div>
  );
};
